import React from 'react'
import moment from 'moment'

const SummaryReport = ({
  startDate,
  endDate,
  initialCash,
  systemTotal,
  closeSummaryModal,
}) => {
  return (
    <>
      <div className='mt-2 text-center h5 shadow-sm p-2 bg-white rounded'>
        Summary Report
      </div>
      <table className='table fs-6'>
        <tbody>
          <tr>
            <td>Start Time</td>
            <td>
              {moment(startDate)
                .subtract(8, 'hour')
                .format('DD/MM/YYYY HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <td className='border-bottom border-primary'>End Time</td>
            <td className='border-bottom border-primary'>
              {moment(endDate)
                .subtract(8, 'hour')
                .format('DD/MM/YYYY HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <td>Initial Cash</td>
            <td>RM {(Math.round(initialCash * 100) / 100).toFixed(2)}</td>
          </tr>
          <tr>
            <td className='border-bottom border-success'>Sales</td>
            <td className='border-bottom border-success'>
              RM{' '}
              {(Math.round((systemTotal - initialCash) * 100) / 100).toFixed(2)}
            </td>
          </tr>
          <tr>
            <td>Total</td>
            <td>RM {(Math.round(systemTotal * 100) / 100).toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
      <div className='text-end mt-4'>
        <button
          type='submit'
          class='btn btn-outline-secondary'
          onClick={closeSummaryModal}
        >
          Close
        </button>
      </div>
    </>
  )
}

export default SummaryReport
